/**
 * @group Functions
 * 
 * @summary
 * <blockquote>Routes error responses to appropriate handlers based on error source</blockquote>
 * 
 * @param {ErrorResponse} errorResponse - The error response to handle
 * @param {string} operation - Description of the operation that failed
 * @returns {NextResponse<ErrorResponse>} NextJS response object with error details
 * 
 * @example
 * ```typescript
 * const errorResponse = analyzeNetworkError(error, 'fetching data');
 * return handleError(errorResponse, 'data fetch operation');
 * ```
 */
import { NextResponse } from 'next/server';
import { handleNetworkError } from './handleNetworkError';
import { handleApplicationError } from './handleApplicationError';
import type { ErrorResponse } from '../../interfaces/ErrorResponse';

export function handleError(
  errorResponse: ErrorResponse,
  operation: string = 'network operation',
): NextResponse<ErrorResponse> {
  if (errorResponse.source === 'network') {
    return handleNetworkError(errorResponse, operation);
  }

  return handleApplicationError(errorResponse, operation);
} 